const gateway=document.querySelector('#gateway');
const motion=matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
const cleanup=[];
if(gateway){
  gateway.querySelectorAll('.portal').forEach(portal=>{
    const visual=portal.querySelector('.portal-visual');
    let frame=0,x=0,y=0;
    const reset=()=>{cancelAnimationFrame(frame);frame=0;visual.style.removeProperty('--tilt-x');visual.style.removeProperty('--tilt-y');};
    portal.addEventListener('pointermove',event=>{
      if(!motion.matches||event.pointerType==='touch')return;
      const bounds=visual.getBoundingClientRect();
      x=-((event.clientY-bounds.top)/bounds.height-.5)*2;
      y=((event.clientX-bounds.left)/bounds.width-.5)*3.5;
      if(!frame)frame=requestAnimationFrame(()=>{frame=0;visual.style.setProperty('--tilt-x',x+'deg');visual.style.setProperty('--tilt-y',y+'deg');});
    },{passive:true});
    portal.addEventListener('pointerleave',reset);
    portal.addEventListener('blur',reset);
    cleanup.push(reset);
  });
}
motion.addEventListener('change',()=>cleanup.forEach(reset=>reset()));
window.addEventListener('pagehide',()=>cleanup.forEach(reset=>reset()));
